import * as Sentry from '@sentry/react'

export default async function SentryHandleError(err) {
  Sentry.captureException(err)
  await Sentry.flush(2000)
}
